module.exports = __webpack_public_path__ + "img/temperature-sm.3cf79351.svg";